import toNumber from 'lodash/toNumber';
import get from 'lodash/get';
import { USER_VAT_PRICES_PARAMETER_HASH } from '@/constants/UserConstants';
import find from 'lodash/find';

const VAT = {
  isVatPrices: function (user) {
    return toNumber(get(find(user?.parameters, ['parameterHash', USER_VAT_PRICES_PARAMETER_HASH]), 'value', 0));
  }
}

export default VAT;